<template>
  <footer>
    <v-container
      class="footer-container"
      v-if="!$route.path.includes('dashboard')"
    >
      <v-row class="py-md-5 py-2">
        <v-col cols="12" md="3" class="">
          <router-link :to="{ name: 'Home' }">
            <v-img
              src="@/assets/logo-horizontal-white.svg"
              width="175"
              justify-md="start"
              alt="Holitime Logo"
              class="footer-logo mb-0 mb-md-3"
            />
          </router-link>
          <p class="footer-description text-start">
            {{ t('footer.baseline') }}
          </p>
          <div class="d-flex align-center ga-2 mt-2">
            <a href="https://www.facebook.com/holitime.org" target="_blank">
              <FacebookIcon size="24" color="white" />
            </a>

            <a href="https://x.com/HolitimeOrg" target="_blank">
              <XIcon size="24" color="white" />
            </a>

            <a href="https://t.me/HolitimeOrg" target="_blank">
              <TelegramIcon
                size="24"
                :style="{
                  position: 'relative',
                  top: '0px',
                  left: '-1px',
                }"
                color="white"
              />
            </a>

            <a href="https://crowdbunker.com/@holitime" target="_blank">
              <CrowdbunkerIcon
                size="24"
                :style="{
                  position: 'relative',
                  top: '0px',
                  left: '-1px',
                }"
                color="white"
              />
            </a>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <h4 class="footer-heading">{{ t('footer.generale_info') }}</h4>
          <div class="py-2" v-for="item in generalInfo">
            <router-link
              class="footer-link"
              :to="{ name: item.link, hash: item.hash }"
            >
              {{ item.text }}
            </router-link>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <h4 class="footer-heading">{{ t('footer.account') }}</h4>
          <div class="py-2" v-for="item in accountInfo" :key="item.text">
            <router-link
              class="footer-link"
              :to="{
                name: item.link,
                hash: item.hash,
                query: item.params
                  ? item.params.reduce((query, param) => {
                      query[param.name] = param.value
                      return query
                    }, {})
                  : {},
              }"
            >
              {{ item.text }}
            </router-link>
          </div>
        </v-col>

        <v-col cols="12" md="3">
          <h4 class="footer-heading">{{ t('footer.holitime') }}</h4>
          <div class="py-2" v-for="item in holitimeInfo" :key="item.text">
            <router-link
              class="footer-link"
              :to="{ name: item.link, hash: item.hash }"
            >
              {{ item.text }}
            </router-link>
          </div>
        </v-col>
      </v-row>

      <v-divider color="#EAFFFA" />

      <v-row class="py-3">
        <v-col class="text-center">
          <p class="footer-copyright">
            {{ t('footer.copyright', { value: currentYear }) }}
          </p>
        </v-col>
      </v-row>
    </v-container>
  </footer>
</template>

<script setup>
import CrowdbunkerIcon from '@/components/icons/CrowdbunkerIcon.vue'
import TelegramIcon from '@/components/icons/TelegramIcon.vue'
import FacebookIcon from '@/components/icons/FacebookIcon.vue'
import XIcon from '@/components/icons/XIcon.vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const currentYear = ref(new Date().getFullYear())

const { t } = useI18n()

const generalInfo = ref([
  {
    text: t('footer.contact'),
    link: 'Home',
    hash: '#section-contact',
  },
  {
    text: t('footer.our_cgu'),
    link: 'CGU',
  },
  {
    text: t('footer.privacy'),
    link: 'DataPolicy',
  },
])

const holitimeInfo = ref([
  {
    text: t('footer.you_are_practitionner'),
    link: 'PractitionerPresentation',
  },
  {
    text: t('appBar.our_mission'),
    link: 'Mission',
  },
  // {
  //   text: t('footer.patient_features'),
  //   link: 'Home',
  //   hash: '#section-features-patient',
  // },
  // {
  //   text: t('footer.practitionner_features'),
  //   link: 'Home',
  //   hash: '#section-features-praticien',
  // },
  // {
  //   text: 'FAQ',
  //   link: 'Home',
  //   hash: '#section-faq',
  // },
])

const accountInfo = ref([
  {
    text: t('footer.create_an_practitionner_account'),
    link: 'Register',
    params: [
      {
        name: 'role',
        value: 'praticien',
      },
    ],
  },
  {
    text: t('footer.create_an_patient_account'),
    link: 'Register',
    params: [
      {
        name: 'role',
        value: 'patient',
      },
    ],
  },
  {
    text: t('footer.become_ambassador'),
    link: 'Partners',
  },
  {
    text: t('footer.login'),
    link: 'Login',
  },
])
</script>

<style scoped>
footer {
  background-color: #007058;
  border-top: 7px solid #004838;
  color: white;
  z-index: 1;
}

/* .footer-logo {
  max-width: 150px;
  position: relative !important;
} */

.footer-description {
  font-size: 14px;
}

.footer-icon {
  color: white;
  font-size: 24px;
}

.footer-heading {
  font-weight: bold;
  margin-bottom: 16px;
}

.footer-link {
  color: #ffffff;
  text-decoration: none;
}

.footer-copyright {
  font-size: 14px;
  margin: 0;
}
</style>
